import { apiFetch } from './apiClient';



export const sincronizarEmails   = (contaId) => apiFetch('/email/sincronizar', { method: 'POST', body: JSON.stringify(contaId ? { conta_id: contaId } : {}) });
export const listarEmailsPainel  = () => apiFetch('/email/mensagens');
export const listarEmailsDaConta = (contaId, pasta) => apiFetch(`/email/contas/${contaId}/mensagens${pasta ? `?pasta=${pasta}` : ''}`);
export const buscarCorpoEmail    = (id) => apiFetch(`/email/mensagens/${id}/corpo`);
export const arquivarEmail       = (id) => apiFetch(`/email/mensagens/${id}/arquivar`, { method: 'PATCH' });
export const excluirEmail        = (id) => apiFetch(`/email/mensagens/${id}`, { method: 'DELETE' });
export const enviarNovoEmail     = (contaId, dados) => apiFetch(`/email/contas/${contaId}/enviar`, { method: 'POST', body: JSON.stringify(dados) });
export const responderEmail      = (id, dados) => apiFetch(`/email/mensagens/${id}/responder`, { method: 'POST', body: JSON.stringify(dados) });
